import { DotsThreeVertical, Icon } from "@phosphor-icons/react";
import DropdownMenu from "./DropdownMenu";
import { Float } from "@headlessui-float/react";
import { Link } from "react-router-dom";

export type TableContextMenuLinkOption = {
    label: string;
    icon: Icon;
    to: string;
};

export type TableContextMenuButtonOption = {
    label: string;
    icon: Icon;
    onClick: () => void;
};

export const isLinkOption = (
    option: TableContextMenuOption
): option is TableContextMenuLinkOption => {
    return Object.prototype.hasOwnProperty.call(option, "to");
};

export type TableContextMenuOption =
    | TableContextMenuLinkOption
    | TableContextMenuButtonOption;

export type TableContextMenuProps = {
    options: TableContextMenuOption[];
};

const TableContextMenuItem = (option: TableContextMenuOption) => {
    const { label, icon: Icon } = option;

    if (isLinkOption(option)) {
        return (
            <DropdownMenu.Item>
                <Link
                    to={option.to}
                    className="flex items-center px-4 py-3 gap-3 hover:bg-surface-light-1 transition-colors w-full"
                >
                    <Icon size={20} />
                    <span className="whitespace-nowrap">{label}</span>
                </Link>
            </DropdownMenu.Item>
        );
    }

    return (
        <DropdownMenu.Item>
            <button
                className="flex items-center px-4 py-3 gap-3 hover:bg-surface-light-1 transition-colors w-full"
                onClick={option.onClick}
            >
                <Icon size={20} />
                <span className="whitespace-nowrap">{label}</span>
            </button>
        </DropdownMenu.Item>
    );
};

const TableContextMenu = (props: TableContextMenuProps) => {
    return (
        <DropdownMenu.Container>
            <Float portal>
                <DropdownMenu.Trigger>
                    {() => <DotsThreeVertical weight="bold" />}
                </DropdownMenu.Trigger>
                <DropdownMenu.Items className="right-3 -top-16">
                    {props.options.map((option) => (
                        <TableContextMenuItem key={option.label} {...option} />
                    ))}
                </DropdownMenu.Items>
            </Float>
        </DropdownMenu.Container>
    );
};

export default TableContextMenu;
